<div
  class="d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-between w-100 mx-1"
>
  <h1
    class="mb-0"
    i18n="
      AnalyticsDashboard|Best Performing Lists Title@@bestPerformingListsTitle"
  >
    Best Performing Lists
  </h1>
  <div class="dashboard-sort d-flex">
    <epc-dashboard-filter-select
      [filterValues]="brandOrgs"
      [selectedValues]="selectedBrandOrgsIds"
      [defaultText]="defaultTextBrandOrg"
      (filterChanged)="setBrandFilterSelection($event)"
      class="dashboard-sort__users mr-3"
    ></epc-dashboard-filter-select>

    <div class="dashboard-sort__date">
      <button
        #dateFilterSelection="atxPopover"
        atxDropdown
        atxPlacement="bottomRight"
        class="btn btn-light d-flex align-items-center justify-content-between"
        [atxDropdownMenu]="menu"
        [atxPopover]="customSelectionDateRange"
        [popoverPlacement]="placement.BOTTOM_LEFT"
        autoClose="outside"
        triggers="manual"
      >
        <span class="font-size-sm">{{ selectedOptionText$ | async }}</span>
        <fa-icon
          class="font-size-sm ml-2"
          [icon]="['fas', 'angle-down']"
        ></fa-icon>
      </button>

      <atx-dropdown-menu
        [extraClasses]="['dashboard-dropdown']"
        #menu="atxDropdownMenu"
      >
        @for (option of dateFilterOptions; track option; let isEven = $even) {
        <atx-dropdown-item
          [class.my-2]="isEven"
          (click)="filterListByDate(option)"
        >
          <span class="font-size-base text-muted">{{ option.label }}</span>
        </atx-dropdown-item>
        }

        <atx-dropdown-item>
          <span
            class="font-size-base text-muted"
            (click)="dateFilterSelection.open()"
            i18n="AnalyticsDashboard|Choose specific dates@@chooseSpecificDates"
            >Choose specific dates</span
          >
        </atx-dropdown-item>
      </atx-dropdown-menu>
    </div>
  </div>
</div>

<ng-template #customSelectionDateRange>
  <atx-date-range-picker
    class="p-2"
    [displayFooterHandlers]="true"
    [displayMonths]="1"
    [useResetText]="true"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [useUTCDayTimeConversion]="true"
    (rangeSelect)="customRangeSelected($event); dateFilterSelection.close()"
  >
  </atx-date-range-picker>
</ng-template>
